import styled from 'styled-components';

export const Container = styled.div`
  position: absolute;
  width: 700px;
  height: 522px;
  left: 0px;
  top: 453px;
  background: #757162;
  margin-left: auto;
  margin-right: auto;
`;

export const RectangleAlert = styled.img`
  position: absolute;
  width: 700px;
  height: 46px;
  left: 0px;
  top: -92px;
`;

export const BarButtonSkills = styled.button`
  position: absolute;
  width: 90px;
  height: 30px;
  left: 363px;
  top: -37px;
  cursor: pointer;
  background-color: #442434;
  border: none;
  background-image: url('./images/barSkills.png');
  background-size: cover;
`;

export const BarButtonWorks = styled.button`
  position: absolute;
  width: 90px;
  height: 30px;
  left: 465px;
  top: -37px;
  cursor: pointer;
  background-color: #442434;
  border: none;
  background-image: url('./images/barWorks.png');
  background-size: cover;
`;

export const BarButtonProjects = styled.button`
  position: absolute;
  width: 90px;
  height: 30px;
  left: 567px;
  top: -37px;
  cursor: pointer;
  background-color: #442434;
  border: none;
  background-image: url('./images/barProjects.png');
  background-size: cover;
`;

export const BarButtonContact = styled.a`
  position: absolute;
  width: 90px;
  height: 30px;
  left: 569px;
  top: 464px;
  cursor: pointer;
  background-color: #442434;
  border: none;
  background-image: url('./images/barContact.png');
  background-size: cover;
`;

export const ButtonEnglish = styled.button`
  position: absolute;
  width: 35px;
  height: 35px;
  left: 572px;
  top: 3px;

  background: url('./images/en.png');
  cursor: pointer;
  border: none;
  background-size: cover;
`;

export const ButtonPortuguese = styled.button`
  position: absolute;
  width: 35px;
  height: 35px;
  left: 615px;
  top: 3px;

  background: url('./images/pt.png');
  cursor: pointer;
  border: none;
  background-size: cover;
`;

export const NamePerson = styled.img`
  position: absolute;
  width: 368px;
  height: 16px;
  left: 39px;
  top: 13px;
`;

export const PersonPicture = styled.img`
  position: absolute;
  width: 152px;
  height: 253px;
  left: 132px;
  top: 38px;
`;

export const DropsBox1 = styled.button`
  position: absolute;
  width: 80px;
  height: 81px;
  left: 36px;
  top: 38px;
  cursor: pointer;
  background-color: #442434;
  border: none;
  background-image: url('./images/DropsBoxCoffee.png');
  background-size: cover;
`;

export const DropsBox2 = styled.button`
  position: absolute;
  width: 80px;
  height: 81px;
  left: 36px;
  top: 126px;
  cursor: pointer;
  background-color: #442434;
  border: none;
  background-image: url('./images/DropsBoxShirt.png');
  background-size: cover;
`;

export const DropsBox3 = styled.button`
  position: absolute;
  width: 80px;
  height: 81px;
  left: 36px;
  top: 214px;
  cursor: pointer;
  background-color: #442434;
  border: none;
  background-image: url('./images/DropsBoxPants.png');
  background-size: cover;
`;

export const ResumeBoard = styled.img`
  position: absolute;
  width: 357px;
  height: 126px;
  left: 295px;
  top: 38px;
`;

export const IconHtml = styled.button`
  position: absolute;
  width: 28px;
  height: 28px;
  left: 308px;
  top: 51px;
  cursor: pointer;
  background-color: #442434;
  border: none;
  background-image: url('./images/icons/git.png');
  background-size: cover;
`;

export const IconCss = styled.button`
  position: absolute;
  width: 28px;
  height: 28px;
  left: 351px;
  top: 51px;
  cursor: pointer;
  background-color: #442434;
  border: none;
  background-image: url('./images/icons/ros.png');
  background-size: cover;
`;

export const IconJs = styled.button`
  position: absolute;
  width: 28px;
  height: 28px;
  left: 394px;
  top: 51px;
  cursor: pointer;
  background-color: #442434;
  border: none;
  background-image: url('./images/icons/linux.png');
  background-size: cover;
`;

export const IconPs = styled.button`
  position: absolute;
  width: 28px;
  height: 28px;
  left: 437px;
  top: 51px;
  cursor: pointer;
  background-color: #442434;
  border: none;
  background-image: url('./images/icons/win.png');
  background-size: cover;
`;

export const IconSolidity = styled.button`
  position: absolute;
  width: 28px;
  height: 28px;
  left: 482px;
  top: 51px;
  cursor: pointer;
  background-color: #442434;
  border: none;
  background-image: url('./images/icons/mac.png');
  background-size: cover;
`;

export const IconTs = styled.button`
  position: absolute;
  width: 28px;
  height: 28px;
  left: 527px;
  top: 51px;
  cursor: pointer;
  background-color: #442434;
  border: none;
  background-image: url('./images/icons/tf.png');
  background-size: cover;
`;

export const IconTw = styled.button`
  position: absolute;
  width: 28px;
  height: 28px;
  left: 570px;
  top: 51px;
  cursor: pointer;
  background-color: #442434;
  border: none;
  background-image: url('./images/icons/devops.png');
  background-size: cover;
`;

export const IconWp = styled.button`
  position: absolute;
  width: 28px;
  height: 28px;
  left: 612px;
  top: 51px;
  cursor: pointer;
  background-color: #442434;
  border: none;
  background-image: url('./images/icons/hard_.png');
  background-size: cover;
`;
export const IconOS = styled.button`
  position: absolute;
  width: 56px;
  height: 56px;
  left: 306px;
  top: 93px;
  cursor: pointer;
  background-color: #442434;
  border: none;
  background-image: url('./images/icons/terminal.png');
  background-size: cover;
`;


export const IconGit = styled.button`
  position: absolute;
  width: 56px;
  height: 56px;
  left: 306px;
  top: 93px;
  cursor: pointer;
  background-color: #442434;
  border: none;
  background-image: url('./images/icons/git.png');
  background-size: cover;
`;

export const IconPython = styled.button`
  position: absolute;
  width: 56px;
  height: 56px;
  left: 380px;
  top: 93px;
  cursor: pointer;
  background-color: #442434;
  border: none;
  background-image: url('./images/icons/python.ico');
  background-size: cover;
`;

export const IconNode = styled.button`
  position: absolute;
  width: 56px;
  height: 56px;
  left: 380px;
  top: 93px;
  cursor: pointer;
  background-color: #442434;
  border: none;
  background-image: url('./images/icons/node.png');
  background-size: cover;
`;

export const IconCpp = styled.button`
  position: absolute;
  width: 56px;
  height: 56px;
  left: 446px;
  top: 93px;
  cursor: pointer;
  background-color: #442434;
  border: none;
  background-image: url('./images/icons/C.png');
  background-size: cover;
`;

export const IconReact = styled.button`
  position: absolute;
  width: 56px;
  height: 56px;
  left: 446px;
  top: 93px;
  cursor: pointer;
  background-color: #442434;
  border: none;
  background-image: url('./images/icons/C.png');
  background-size: cover;
`;

export const IconAI = styled.button`
  position: absolute;
  width: 56px;
  height: 56px;
  left: 515px;
  top: 93px;
  cursor: pointer;
  background-color: #442434;
  border: none;
  background-image: url('./images/icons/AIML.png');
  background-size: cover;
`;

export const IconNpm = styled.button`
  position: absolute;
  width: 56px;
  height: 56px;
  left: 515px;
  top: 93px;
  cursor: pointer;
  background-color: #442434;
  border: none;
  background-image: url('./images/icons/npm.png');
  background-size: cover;
`;

export const IconUnity = styled.button`
  position: absolute;
  width: 56px;
  height: 56px;
  left: 584px;
  top: 93px;
  cursor: pointer;
  background-color: #442434;
  border: none;
  background-image: url('./images/icons/unity.png');
  background-size: cover;
`;

export const IconRobot = styled.button`
  position: absolute;
  width: 56px;
  height: 56px;
  left: 584px;
  top: 93px;
  cursor: pointer;
  background-color: #442434;
  border: none;
  background-image: url('./images/icons/robot.png');
  background-size: cover;
`;

export const ScoreBoard = styled.img`
  position: absolute;
  width: 357px;
  height: 129.96px;
  left: 295px;
  top: 162px;
`;

export const VisorBoard = styled.img`
  position: absolute;
  width: 624px;
  height: 152px;
  left: 38px;
  top: 302px;
`;

export const BottomBase = styled.div`
  position: absolute;
  width: 700px;
  height: 520px;
  left: 0px;
  top: 2px;

  background: #757162;
`;

export const Modal = styled.img`
  display: none;
  position: absolute;
  width: 630px;
  height: 413px;
  left: 29px;
  top: 38px;
  border: none;
  background-image: url('./images/modal/ASkills.png');
  background-size: cover;
`;

export const EasterButton = styled.button`
  position: absolute;
  width: 10px;
  height: 10px;
  left: 619px;
  top: -438px;
  border: none;
  background-image: url('./images/buttonRedClick.gif');
  background-size: cover;
  cursor: pointer;
`;
